<template>
  <section class="main">
    <v-page-header :title="$t('account.profile.password.reset')" :showPrevButton="false" />

    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
          <div class="box">
            <form action method="POST" novalidation @submit="onSubmitObject">
              <div class="form-block">
                <div
                  class="form-group"
                  :class="{ 'form-group--error' : $v.object.password.$error, 'form-group--required' : $v.object.password.$params.required }"
                >
                  <label for="form-field-password">{{ $t('form.password') }}</label>
                  <input
                    type="password"
                    id="form-field-password"
                    name="password"
                    class="form-control"
                    v-model="$v.object.password.$model"
                  />
                </div>
                <div
                  class="form-group"
                  :class="{ 'form-group--error' : $v.object.password_confirm.$error, 'form-group--required' : $v.object.password.$params.required }"
                >
                  <label for="form-field-password-confirm">{{ $t('form.password_confirm') }}</label>
                  <input
                    type="password"
                    id="form-field-password-confirm"
                    name="password_confirm"
                    class="form-control"
                    v-model="$v.object.password_confirm.$model"
                  />
                </div>
                <!-- <div
                  class="form-group"
                  :class="{
                    'form-group--error': $v.object.hasAcceptedUserTracking.$error
                  }">
                    <v-account-form-activity-tracking
                      v-model="$v.object.hasAcceptedUserTracking.$model"
                      :hasError="$v.object.hasAcceptedUserTracking.$error"
                    />
                </div> -->
                <div class="form-group">
                  <button
                    role="button"
                    type="submit"
                    class="button"
                    :title="$t('form.submit')"
                    :disabled="objectFormDisabled"
                  >{{ $t('form.submit') }}</button>
                </div>
              </div>
            </form>
          </div>

          <v-form-message
            :id="'form-' + dialogStatus"
            :message="dialogMessageTitle"
            :type="dialogStatus"
            :isVisible="showDialog"
            :autoCloseTimeout="1500"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import PageHeader from "../partials/PageHeader";
import FormMessage from "../partials/Forms/FormMessage";
// import AccountFormActivityTracking from './AccountAcceptActivityTrackingForm.vue';

export default {
  data() {
    return {
      objectFormDisabled: false,
      object: {
        token: this.$route.params.token,
        password: "",
        password_confirm: "",
        // hasAcceptedUserTracking: false,
      },
      dialogMessageTitle: null,
      dialogStatus: null
    };
  },
  computed: {
    showDialog: function() {
      return this.dialogMessageTitle !== null;
    }
  },
  components: {
    vPageHeader: PageHeader,
    vFormMessage: FormMessage,
    // vAccountFormActivityTracking: AccountFormActivityTracking,
  },
  validations: function() {
    return {
      object: {
        password: {
          required
        },
        password_confirm: {
          required,
          sameAsPassword: sameAs("password"),
        },
       /*  hasAcceptedUserTracking: {
          required,
          isAccepted: value => value === true,
        } */
      }
    };
  },
  methods: {
    onSubmitObject: function(event) {
      event.preventDefault();

      this.dialogMessageTitle = null;
      this.objectFormDisabled = true;

      this.$v.object.$touch();

      if (this.$v.object.$invalid) {
        this.dialogMessageTitle = this.$t("form.error_form");
        this.dialogStatus = "error";
        this.objectFormDisabled = false;
      } else {
        let promise = this.$api
          .clearParams()
          .post("password/reset", this.object);

        promise
          .then(
            (response => {
              this.dialogMessageTitle = this.$t(
                "account.profile.password.reset.success"
              );
              this.dialogStatus = "success";
              this.$router.push({ name: "login" });
            }).bind(this)
          )
          .catch(
            (error => {
              this.dialogMessageTitle = this.$t("form.error_form");
              this.dialogStatus = "error";
            }).bind(this)
          )
          .finally(
            (() => {
              this.objectFormDisabled = false;
            }).bind(this)
          );
      }
    }
  }
};
</script>
